export const PAYMENT_AMOUNT_MIN = 5;
export const PAYMENT_AMOUNT_MAX = 999999;
export const LOAN_AMOUNT_MIN_VALUE = 20000;
export const LOAN_AMOUNT_MAX_VALUE = 176000;
export const LOAN_AMOUNT_CHANGE_STEP = 5000;
export const LOAN_AMOUNT_INITIAL_VALUE = 80000;
export const LOAN_PERIOD_MIN_VALUE = 10;
export const LOAN_PERIOD_MAX_VALUE = 20;
export const LOAN_PERIOD_INITIAL_VALUE = 15;
export const LOAN_PERIOD_CHANGE_STEP = 1;
export const GRACE_PERIOD_DAYS = 7;
export const GESV_RATE = '179%';
export const DAILY_PENALTY_RATE = '0,3%';
export const ALLOWED_MIN_AGE = 21;
export const MAX_CHILDREN_COUNT = 9;
export const MAX_SALARY_VALUE = 99999999;
export const MIN_SALARY_VALUE = 1;
export const PROMO_CODE_MIN_LENGTH = 3;
